export const CancelAppointmentPublic = 'cancel-appointment';

export const CancelAppointmentPublicHashName = 'hash';
export const CancelAppointmentPublicBusinessId = 'businessId';
export const CancelAppointmentPublicWithBusinessId = `:${CancelAppointmentPublicBusinessId}`;
export const CancelAppointmentPublicWithParamOld = `:${CancelAppointmentPublicBusinessId}/:${CancelAppointmentPublicHashName}`;

export const CancelAppointmentPublicHashQueryParam = 'h';
